var m = require('mithril');
var prop = require('mithril/stream');
var formGroup = require('../formGroup');


var component = {};
component.googleApiActive = prop(true);

window.gm_authFailure = function() {
  component.googleApiActive(false);
  m.redraw();
  setTimeout(()=>{ 
    document.getElementById('search').focus();
   }, 1);
}

component.oninit = function (vnode){
  var ctrl = this;
  ctrl.record = vnode.attrs.record;
  ctrl.fieldId = vnode.attrs.fieldId;
  ctrl.nameField = vnode.attrs.nameField;
  ctrl.streetAddressField = vnode.attrs.streetAddressField;
  ctrl.latitudeField = vnode.attrs.latitudeField;
  ctrl.longitudeField = vnode.attrs.longitudeField;
};

component.view = function (vnode) {
  var ctrl = this;
  return m(formGroup, [
    m('label', 'Address:'),
    m('input.form-control.mb2' + (component.googleApiActive() ? '' : '.dn') , {
      id: ctrl.fieldId + 'searchTextField', 
      type: "text", 
      size: "50",
      oninput: (ev) => ctrl.streetAddressField(ev.target.value),
      oncreate: function(){
        var input = document.getElementById(ctrl.fieldId + 'searchTextField');
        ctrl.record && ctrl.record != undefined ? input.value = ctrl.record.streetAddress: undefined;
        initAutocomplite(ctrl)
      }
    }),
    m('input.form-control.mb2' + (component.googleApiActive() ? '.dn' : '') , {
      id: 'search', 
      size: "50",
      type:'text',
      oninput: (ev) => ctrl.streetAddressField(ev.target.value),
      value: ctrl.streetAddressField(),
    }),
    ctrl.googleApiActive() ? '' :
      m('div',[
        m('label', 'Latitude:'),
        m('input.form-control.mb2', {
          type:'text',
          oninput: (ev) => ctrl.latitudeField(ev.target.value),
          value: ctrl.latitudeField(),
        }),  
        m('label', 'Longitude:'),
        m('input.form-control.mb2', {
          type:'text',
          oninput: (ev) => ctrl.longitudeField(ev.target.value),
          value: ctrl.longitudeField(),
        })
      ]),
    
  ])
};

function initAutocomplite(ctrl){
  var input = document.getElementById(ctrl.fieldId + 'searchTextField');
  autocomplete = new google.maps.places.Autocomplete(
    input,
    {
      type: ['establishment', 'address'],
      componentRestrictions: {'country': ['US']},
      fields: ['place_id', 'geometry', 'name', 'formatted_address']
    }
  )
  autocomplete.addListener('place_changed', function(){onPlaceChanged(ctrl)})
}

function onPlaceChanged(ctrl){
  var input = document.getElementById(ctrl.fieldId + 'searchTextField');
  let place = autocomplete.getPlace();
  if(!place || !place.geometry){
    input.value = ''
    //input.placeHolder = 'Enter a Place'
  }else{
    input.innerHTML = place.name;
    if(ctrl.nameField() == null || ctrl.nameField() ===''){
      ctrl.nameField(place.name);
      m.redraw();
    }
    ctrl.streetAddressField(place.formatted_address); 
    ctrl.latitudeField(place.geometry.location.lat());
    ctrl.longitudeField(place.geometry.location.lng());
  }
}

module.exports = component;
